import React from 'react';
import { PrivateRoute } from '../../components/HasRights/HasRights';
import { Permissions } from '../../const/permissions';
import appRoutes from '@/configs/routes';
import PageDictionaries from '../../domains/Translations/pages/Dictionaries/PageDictionaries';
import PageDictionaryCreate from '../../domains/Translations/pages/Dictionaries/PageDictionaryCreate';
import PageDictionaryEdit from '../../domains/Translations/pages/Dictionaries/PageDictionaryEdit';
import PageTranslationsDetails from '../../domains/Translations/pages/Translations/PageTranslationDetails';
import PageDictionariesImport from '../../domains/Translations/pages/Dictionaries/PageDictionariesImport';
import PageDictionariesImportSuccess from '../../domains/Translations/pages/Dictionaries/PageDictionariesImportSuccess';



export const dictionariesRoutes = ({ urlPrefix = null }) => [
  {
    path: appRoutes.urlPageDictionaries({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.TRANSLATIONS.DICTIONARIES.LIST.VIEW_PAGE ]}>
        <PageDictionaries />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPageDictionaryCreate({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.TRANSLATIONS.DICTIONARIES.LIST.CREATE ]}>
        <PageDictionaryCreate />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPageDictionaryEdit({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.TRANSLATIONS.DICTIONARIES.DETAILS.EDIT ]}>
        <PageDictionaryEdit />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPageTranslationDetails({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.TRANSLATIONS.DICTIONARIES.DETAILS.VIEW ]}>
        <PageTranslationsDetails />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPageDictionariesImport({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.TRANSLATIONS.DICTIONARIES.FILES.IMPORT ]}>
        <PageDictionariesImport />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPageDictionariesImportSuccess({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.TRANSLATIONS.DICTIONARIES.FILES.IMPORT ]}>
        <PageDictionariesImportSuccess />
      </PrivateRoute>
    ),
  },
];
